import * as amplitude from '@amplitude/analytics-browser';

// Wrapped in try/catch on purpose: a previous attempt at this (PR #632) crashed
// the whole app on load (blank page, "service down") because this file is
// imported before ReactDOM.render in src/index.js, and an uncaught error here
// takes the entire SPA down with it. defaultTracking is explicitly disabled to
// keep this to the one manual trackEvent call we need, nothing automatic.
//
// Exported as a function (instead of running inline at module load) so
// amplitude.smoke.test.js can call it directly under different env var states
// without needing `require`/`jest.resetModules()` to re-evaluate the module.
export const initAmplitude = () => {
  try {
    if (process.env.REACT_APP_AMPLITUDE) {
      amplitude.init(process.env.REACT_APP_AMPLITUDE, {
        defaultTracking: false
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize Amplitude', error);
  }
};

initAmplitude();
